import { render, staticRenderFns } from "./userReviewe.vue?vue&type=template&id=90d2ba52&scoped=true"
import script from "./userReviewe.vue?vue&type=script&lang=js"
export * from "./userReviewe.vue?vue&type=script&lang=js"
import style0 from "./userReviewe.vue?vue&type=style&index=0&id=90d2ba52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d2ba52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90d2ba52')) {
      api.createRecord('90d2ba52', component.options)
    } else {
      api.reload('90d2ba52', component.options)
    }
    module.hot.accept("./userReviewe.vue?vue&type=template&id=90d2ba52&scoped=true", function () {
      api.rerender('90d2ba52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/userReviewe.vue"
export default component.exports